import { captureExceptions } from 'utils/SentryHelpers'


function failed(errors) {
  captureExceptions(errors)
  return <div/>
}

export function makeDefaultFailedContainer(component, options) {
  return Marty.createContainer(component, Object.assign(options, { failed }))
}


// WEBPACK FOOTER //
// ./src/scripts/components/container/index.js